import * as styles from './styles.css';
import { Button, Checkbox, Chips, FormField, NumberInput } from '@cian/ui-kit';
import { NBSP } from 'shared/constants/symbols';

interface ISecondStepFormProps {
  chipsError?: string;
  selectedChips: string[];
  price?: number;
  priceError?: string;
  priceAdornment: string;
  isLoading: boolean;
  marketingCheck: boolean;
  marketingLink: string | undefined;
  privacyPolicyLink: string | undefined;
  personalDataLink: string | undefined;
  onMarketingCheck: VoidFunction;
  onBtnNext: VoidFunction;
  onChangePrice: (value: number) => void;
  onChangeSelectedChips: (value: string[]) => void;
}

export const SecondStepForm: React.FC<ISecondStepFormProps> = ({
  chipsError,
  selectedChips,
  price,
  priceError,
  priceAdornment,
  isLoading,
  marketingCheck,
  marketingLink,
  personalDataLink,
  privacyPolicyLink,
  onMarketingCheck,
  onBtnNext,
  onChangePrice,
  onChangeSelectedChips,
}) => {
  return (
    <div>
      <FormField label="На какой срок сдаёте" errorMessage={chipsError}>
        <Chips
          value={selectedChips}
          onChange={onChangeSelectedChips}
          options={[
            { value: 'Посуточно', label: 'Посуточно' },
            { value: 'От года', label: 'От года' },
          ]}
        />
      </FormField>
      <FormField label="Желаемая арендная плата" errorMessage={priceError}>
        <NumberInput
          size="M"
          value={price}
          onChange={onChangePrice}
          rightAdornment={<div className={styles['right-adornment']}>₽/{priceAdornment}.</div>}
        />
      </FormField>
      <Button loading={isLoading} onClick={onBtnNext} fullWidth size="M">
        Дальше
      </Button>
      <div className={styles['notice-container']}>
        <Checkbox checked={marketingCheck} onChange={onMarketingCheck} />
        <div className={styles['notice']}>
          Соглашаюсь на{' '}
          <a href={marketingLink} className={styles['link']} target="_blank" rel="noreferrer">
            рассылки и звонки
          </a>
        </div>
      </div>
      <div className={styles['notice']}>
        Нажимая «Дальше», я{NBSP}даю{NBSP}
        <a href={personalDataLink} className={styles['link']} target="_blank" rel="noreferrer">
          Согласие на обработку персональных данных
        </a>{' '}
        в{NBSP}соответствии с{' '}
        <a href={privacyPolicyLink} className={styles['link']} target="_blank" rel="noreferrer">
          Политикой конфиденциальности.
        </a>
      </div>
    </div>
  );
};
